/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ionic-angular/components/icon/icon';
import * as import2 from 'ionic-angular/config/config';
import * as import3 from 'ionic-angular/components/item/reorder';
const styles_Reorder:any[] = ([] as any[]);
export const RenderType_Reorder:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_Reorder,
  data: {}
}
);
export function View_Reorder_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'ion-icon',[
      [
        'name',
        'reorder'
      ]
      ,
      [
        'role',
        'img'
      ]

    ]
      ,[[
        2,
        'hide',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(147456,(null as any),0,import1.Icon,[
      import2.Config,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    const currVal_1:any = 'reorder';
    ck(v,1,0,currVal_1);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1)._hidden;
    ck(v,0,0,currVal_0);
  });
}
function View_Reorder_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'ion-reorder',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).onClick($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },View_Reorder_0,RenderType_Reorder)),
    import0.ɵdid(49152,(null as any),0,import3.Reorder,[import0.ElementRef],(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const ReorderNgFactory:import0.ComponentFactory<import3.Reorder> = import0.ɵccf('ion-reorder',import3.Reorder,View_Reorder_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL25vZGVfbW9kdWxlcy9pb25pYy1hbmd1bGFyL2NvbXBvbmVudHMvaXRlbS9yZW9yZGVyLm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL25vZGVfbW9kdWxlcy9pb25pYy1hbmd1bGFyL2NvbXBvbmVudHMvaXRlbS9yZW9yZGVyLmQudHMiLCJuZzovLy9ob21lL3J1bm5lci93b3JrL3dlYi1vcmRlcmluZy1hcHAvd2ViLW9yZGVyaW5nLWFwcC9ub2RlX21vZHVsZXMvaW9uaWMtYW5ndWxhci9jb21wb25lbnRzL2l0ZW0vcmVvcmRlci5kLnRzLlJlb3JkZXIuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL25vZGVfbW9kdWxlcy9pb25pYy1hbmd1bGFyL2NvbXBvbmVudHMvaXRlbS9yZW9yZGVyLmQudHMuUmVvcmRlcl9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxpb24taWNvbiBuYW1lPVwicmVvcmRlclwiPjwvaW9uLWljb24+IiwiPGlvbi1yZW9yZGVyPjwvaW9uLXJlb3JkZXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0lDQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtPQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBQTs7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTs7O0lBQVU7SUFBVixTQUFVLFNBQVY7O0lBQUE7SUFBQSxTQUFBLFNBQUE7Ozs7O01DQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtJQUFBO2dCQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./node_modules/ionic-angular/components/item/reorder.ngfactory.ts